"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAxiosRequestConfigWithAuth = void 0;
const isAxiosRequestConfigWithAuth = function (config) {
  return "includeAuth" in config;
};
exports.isAxiosRequestConfigWithAuth = isAxiosRequestConfigWithAuth;